/** @format */

import { GlobalPositionStrategy, Overlay, OverlayConfig, OverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import { Injectable, Injector } from "@angular/core";
import { LoaderWithMessageComponent } from "../components/modals/loader-with-message/loader-with-message.component";
import { LoaderComponent } from "../components/modals/loader/loader.component";
import { LOADER_DATA_VAR } from "../constants/loader.constants";

@Injectable({
  providedIn: "root"
})
export class LoaderService {
  private overlayRef: OverlayRef;

  constructor(private overlay: Overlay) {}

  show(message?: string): void {
    if (this.overlayRef?.hasAttached()) {
      return;
    }
    const { positionStrategy, width, backdropClass, hasMessage } = this.calcLoaderProperties(!!message);
    const config = new OverlayConfig({
      hasBackdrop: true,
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      width,
      backdropClass
    });
    this.overlayRef = this.overlay.create(config);
    if (hasMessage) {
      const portal = new ComponentPortal(
        LoaderWithMessageComponent,
        null,
        Injector.create({
          providers: [{ provide: LOADER_DATA_VAR, useValue: message }]
        })
      );
      this.overlayRef.attach(portal);
      return;
    }
    const portal = new ComponentPortal(LoaderComponent, null);
    this.overlayRef.attach(portal);
  }

  hide(): void {
    this.overlayRef?.detach();
    this.overlayRef?.dispose();
  }

  private calcLoaderProperties(hasMessage: boolean): {
    positionStrategy: GlobalPositionStrategy;
    width: string;
    backdropClass: string;
    hasMessage: boolean;
  } {
    const positionStrategy = this.overlay.position().global();
    let width = "100vh";
    let backdropClass = "cdk-overlay-transparent-backdrop";
    if (hasMessage) {
      width = "initial";
      backdropClass = "exp-loader-with-message";
      positionStrategy.centerHorizontally().centerVertically();
    } else {
      positionStrategy.top("0px").right("0px");
    }
    return { positionStrategy, width, backdropClass, hasMessage };
  }
}
